/**
 * 检测任务模块统一的 API 错误信息提取工具。
 *
 * 从 `useTaskActions` 内提取出来，供 hook 与页面组件（如任务详情页）共用，
 * 避免各处直接用 `error.message` 而丢掉后端返回的具体原因
 * （FastAPI 的 detail / ApiErrorResponse 的 message 等，见 shared/utils/errorHandler）。
 */
import { getErrorMessage } from '@/shared/utils/errorHandler';

/** `getErrorMessage` 在拿不到任何信息时给出的兜底文案 */
const GENERIC_MESSAGE = '操作失败，请重试';

/**
 * 提取可展示给用户的错误信息。
 *
 * `getErrorMessage` 总会返回非空字符串（最后兜底为「操作失败，请重试」），
 * 所以这里要显式识别该兜底值并改用调用方给的、更贴合场景的 fallback
 * （如「停止任务失败」），否则 fallback 形同虚设。
 */
export function getApiErrorMessage(error: any, fallback: string): string {
  const message = getErrorMessage(error);
  if (!message || message === GENERIC_MESSAGE) return fallback;
  return message;
}
